__turbopack_context__.v({
  "className": "inter_4a4f7444-module__UHjWDq__className",
  "variable": "inter_4a4f7444-module__UHjWDq__variable",
});
